import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OptionalBenefitRate } from 'src/app/service/web-api-client';

@Component({
  selector: 'app-quote-per-member-selector',
  templateUrl: './per-member-selector.component.html',
  styleUrl: './per-member-selector.component.css'
})
export class PerMemberSelectorComponent implements OnInit {

  @Input() model: OptionalBenefitRate;
  @Input() depenentsCount: number = 0;
  @Input() optionName: string;
  @Output() optionChanged: EventEmitter<string> = new EventEmitter();

  appliesForOwner: boolean = true;
  showDependents: boolean = false;
  dependents: any[] = [];
  dependentSelected: number;

  get isReady(): boolean {
    return this.model && this.optionName != null && this.optionName.length > 0;
  }

  constructor() {
  }

  ngOnInit(): void {

    if (this.isReady) {

      this.appliesForOwner = this.model.appliesForOwner == true;

      if (this.depenentsCount && this.depenentsCount > 0) {
        let dependentArray: any[] = [];
        // dependentArray.push({
        //   id: 0,
        //   text: 'Ninguno'
        // });
        const dCount = (this.depenentsCount - 1);
        console.log('depenentsCount', dCount);
        if (dCount == 1) {
          dependentArray.push({
            id: 1,
            text: '1',
            selected: this.model.applicableDependentsCount <= 1
          });
        } else {          
          for (let i = 1; i <= dCount; i++) {
            dependentArray.push({
              id: i,
              text: i.toString(),
              selected: this.model.applicableDependentsCount <= i
            });
          }
        }
        this.dependents = dependentArray;
        this.showDependents = this.dependents.length > 0;

        this.dependentSelected = this.model.applicableDependentsCount > 0
          ? this.model.applicableDependentsCount
          : 0;
      }
    }
  }

  onDependentSelected(id: any): void {
    if (this.dependentSelected == id) {
      this.dependentSelected = 0;
    } else {
      this.dependentSelected = id
    }

    if (this.dependents[id - 1].selected) {
      this.dependents[id - 1].selected = !this.dependents[id - 1].selected;
    } else {
      this.dependents[id - 1].selected = true;
    }



    const selectedDependents = this.dependents.filter(d => d.selected).length;
    console.log('dependent selected', this.dependentSelected, selectedDependents);

    this.model.applicableDependentsCount = selectedDependents;
    this.optionChanged.emit();
  }

  onTitlularChecked(checked: any): void {
    this.appliesForOwner = checked;
    console.log(this.optionName, " - appliesForOwner (onTitlularChecked): ", this.appliesForOwner);
    console.log(this.optionName, " - model (onDependentSelected): ", JSON.stringify(this.model));

    this.model.appliesForOwner = this.appliesForOwner;
    this.optionChanged.emit(this.optionName);
  }
}
